import moment from 'moment'
import getDateFormat from './GetDateFormat'

export default function getDate(date) {
  return moment(date).format(getDateFormat())
}